import { gql } from '@apollo/client';

export * from './appProtections.query.generated';

export const APP_PROTECTIONS = gql`
  query appProtections(
    $appId: ID!
    $productTypes: [AppProductTypeEnum!]
    $certificationTypes: [AppCertificationTypeEnum!]
    $statuses: [AppProtectionStatusEnum!]
  ) {
    appProtections(
      appId: $appId
      productTypes: $productTypes
      certificationTypes: $certificationTypes
      statuses: $statuses
    ) {
      id
      productType
      taskCounts {
        count
        criticality
      }
      ... on Backup {
        id
        backupStatus: status
        certificationValidated
        certificationVerified
        name
        lastBackup
        backupCreator: creator {
          id
          name
        }
        policy {
          remove
        }
      }
      ... on ContinuityEscrow {
        id
        escrowStatus: status
        certificationValidated
        certificationVerified
        certificationCertified
        lastProvider
        depositor {
          id
          companyName
        }
        beneficiary {
          id
          companyName
          companyWebsite
        }
        agreement {
          id
          agreementForm
        }
        escrowInvitation {
          id
          status
        }
        policy {
          remove
        }
      }
      ... on CustodianProfile {
        id
        custodianStatus: status
        activatedAt
        certificationValidated
        name
        custodianCreator: creator {
          id
          name
        }
        policy {
          remove
        }
      }
      ... on SaasEscrow {
        id
        escrowStatus: status
        certificationValidated
        certificationVerified
        certificationCertified
        lastDeposit
        depositor {
          id
          companyName
        }
        beneficiary {
          id
          companyName
          companyWebsite
        }
        agreement {
          id
          agreementForm
        }
        escrowInvitation {
          id
          status
        }
        policy {
          remove
        }
      }
      ... on SoftwareEscrow {
        id
        escrowStatus: status
        certificationValidated
        certificationVerified
        certificationCertified
        lastDeposit
        depositor {
          id
          companyName
        }
        beneficiary {
          id
          companyName
          companyWebsite
        }
        agreement {
          id
          agreementForm
        }
        escrowInvitation {
          id
          status
        }
        policy {
          remove
        }
      }
    }
  }
`;
